import { useCallback, useEffect } from "react";
import {
  DeviceHelper,
  eventService,
  IAppState,
  useInitialHomePage,
  userProfileHelper,
  useSelector,
} from "@nf/common";
import { ROUTES } from "@nf/constants";
import {
  useSetCurrentSubProfile,
  useRedirectToProfileScreen,
  useRouter,
  useRedirectUrlParam,
  useUserSubscriptions,
} from "../../../hooks";
import {
  MOBILE_PARAM_SUBSCRIPTION_VALUE,
  MOBILE_PARAM_SUBSCRIPTIONS,
} from "../../../screens/WelcomeScreen/WelcomeScreen";

export const useRedirectOnSignIn = () => {
  const { subprofiles } = useSelector((state: IAppState) => state.user);
  const router = useRouter();
  const redirectUrl = useRedirectUrlParam();

  const subProfiles = subprofiles?.Data?.subprofiles;
  const hasPinCode = subprofiles?.Data?.auth?.PinCodeId;
  const { hasActiveSubscriptions } = useUserSubscriptions();

  const setCurrentProfile = useSetCurrentSubProfile();

  const { getInitialHomePage } = useInitialHomePage();
  const redirectToProfileSelectionScreen = useRedirectToProfileScreen();

  const isMobile = useCallback(() => DeviceHelper.isMobile(), []);

  useEffect(() => {
    const subscription = eventService.onSignInSuccessEvent(() => {
      if (redirectUrl) {
        const owner = userProfileHelper.findMainProfile(subProfiles);

        if (owner && !hasPinCode) {
          setCurrentProfile(owner).then(() => {
            router.replace(redirectUrl);
          });
        } else {
          redirectToProfileSelectionScreen();
        }
        return;
      }

      if (isMobile()) {
        router.replace(
          hasActiveSubscriptions
            ? {
                pathname: ROUTES.WELCOME,
                query: {
                  [MOBILE_PARAM_SUBSCRIPTIONS]: MOBILE_PARAM_SUBSCRIPTION_VALUE,
                },
              }
            : {
                pathname: ROUTES.PAYMENT_SUBSCRIPTION,
              }
        );
        return;
      }

      if (subProfiles?.length && subProfiles.length > 1) {
        redirectToProfileSelectionScreen();
      }

      if (subProfiles?.length && subProfiles.length === 1) {
        const initialHomePage = getInitialHomePage(subProfiles[0]);

        setCurrentProfile(subProfiles[0]).then(() => {
          router.replace(initialHomePage);
        });
      }
    });
    return () => {
      eventService.unsubscribe(subscription);
    };
  }, [hasPinCode, subProfiles, redirectUrl, hasActiveSubscriptions, isMobile]);
};
